import React from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';

import callOnce from 'ggApp/utils/callOnce';
import { Translator } from 'ggApp/modules/translator';
import { registerToolTipActivation as registerToolTipActivationAction } from 'ggApp/modules/gaAnalytics';
import Tooltip from 'ggApp/shared/containers/tooltip';

import { CURRENCIES_ASSOCIATION, STORE_TYPE } from 'ggApp/modules/store/constants';
import {
    SingleProductWrapper,
    ProductImage,
    ProductName,
    ProductCoreAttribute,
    TextWrapper,
    ToolTipText,
    Icon,
    ToolTipWrap,
} from './styled';

export default class SingleProduct extends React.PureComponent {
    handleTooltipActivation = callOnce(() => {
        const { location, product, orderActive } = this.props;
        registerToolTipActivationAction(location, product, orderActive);
    });

    goToProductPage = () => {
        const {
            product: { variant },
            activeStore: { store_type: storeType },
            mainTransition,
            transitionTo,
        } = this.props;
        if (!variant || !variant.product || !variant.product.slug) return;
        if (storeType === STORE_TYPE.MAIN) {
            // eslint-disable-next-line consistent-return
            return mainTransition(`/products/${variant.product.slug}`, true);
        }
        if (storeType === STORE_TYPE.GROVER_PAY) {
            const params = {
                product_id: variant.product.id,
                variant_id: variant.id,
            };
            // eslint-disable-next-line consistent-return
            return transitionTo(`/landing?${qs.stringify(params)}`, false);
        }
    };

    render() {
        const {
            product,
            big,
            absolute,
            withBorderBottom,
            desktopColumn,
            mobile,
            activeStore: { store_type: storeType, default_currency: defaultCurrency },
            isDesktopUser,
            children,
        } = this.props;

        const { variant, buyout } = product || {};

        const { name, core_attribute: coreAttribute, image_url: imageUrl } = variant || {};
        const { months_to_own: monthsToOwn } = buyout || {};
        const { months_required: monthsRequired } = monthsToOwn || {};
        const linkActive = [STORE_TYPE.GROVER_PAY, STORE_TYPE.MAIN].includes(storeType);
        const currency = CURRENCIES_ASSOCIATION[defaultCurrency];

        return (
            <SingleProductWrapper absolute={absolute} withBorderBottom={withBorderBottom} big={big}>
                <ProductImage
                    img={imageUrl}
                    big={big}
                    mobile={mobile}
                    desktopColumn={desktopColumn}
                    onClick={linkActive && this.goToProductPage}
                />
                <TextWrapper absolute={absolute} mobile={mobile}>
                    <ProductName big={big} onClick={linkActive && this.goToProductPage}>
                        {name}
                    </ProductName>
                    {coreAttribute && (
                        <ProductCoreAttribute big={big}>{coreAttribute}</ProductCoreAttribute>
                    )}
                    {monthsRequired && (
                        <ToolTipWrap
                            onClick={!isDesktopUser ? this.handleTooltipActivation : () => {}}
                            onMouseEnter={isDesktopUser ? this.handleTooltipActivation : () => {}}
                        >
                            <Tooltip
                                tooltipTK="RENT_TO_OWN_KEEP_IT_FOREVER_DESCRIPTION"
                                // +1 because we're explaning how many payments you need to make —
                                // not how many months you need to rent it for in terms of time.
                                // Each month is paid in advance, which is why we're adding +1 here.
                                withValues={{ period: monthsRequired + 1, currency }}
                            >
                                <ToolTipText>
                                    <Translator tk="RENT_TO_OWN_KEEP_IT_FOREVER" />
                                </ToolTipText>
                            </Tooltip>
                            <Icon color="rgba(51, 51, 51, 0.5)" />
                        </ToolTipWrap>
                    )}
                </TextWrapper>
                {children}
            </SingleProductWrapper>
        );
    }
}

SingleProduct.propTypes = {
    product: PropTypes.shape({
        variant: PropTypes.object,
    }).isRequired,
    activeStore: PropTypes.shape({
        store_type: PropTypes.string,
        default_currency: PropTypes.string,
    }).isRequired,
    location: PropTypes.shape({}).isRequired,
    orderActive: PropTypes.shape({}).isRequired,
    big: PropTypes.bool,
    absolute: PropTypes.bool,
    withBorderBottom: PropTypes.bool,
    desktopColumn: PropTypes.bool,
    mobile: PropTypes.bool,
    mainTransition: PropTypes.func.isRequired,
    transitionTo: PropTypes.func.isRequired,
    isDesktopUser: PropTypes.bool.isRequired,
    children: PropTypes.node,
};

SingleProduct.defaultProps = {
    big: true,
    absolute: true,
    withBorderBottom: false,
    desktopColumn: false,
    mobile: false,
    children: null,
};
